export const TYPES_BUTS_MARQUES = [
    "coup franc",
    "penalty",
    "autre"
]



// WEBPACK FOOTER //
// ./src/data/types_buts_marques.js